import BaseElement from "./BaseElement";

export default class TableColumn extends BaseElement {

  title;

  constructor(title) {
    super()

    this.styles.setRules({
      'border-width': '1px',
      'border-style': 'solid',
      'padding-top': '2px',
      'padding-bottom': '2px',
      'padding-left': '5px',
      'padding-right': '5px'
    });

    this.title = title;
  }

  setTitle(title) {
    this.title = title;
  }

  /**
   * @param {boolean} tableColumnMode
   * @return {string}
   */
  toHTML(tableColumnMode = false, truncateLongText = false) {
    const truncationStyles = truncateLongText
      ? 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'
      : '';
    return `<th style="${this.styles.getStyle(tableColumnMode)}${truncationStyles}">${this.title}</th>`;
  }

  /**
   * @param {boolean} tableColumnMode
   * @return {{id: string, stringStyles: string, styles: Styles, title: string}}
   */
  toData(tableColumnMode = false) {
    return {
      id: this.id,
      stringStyles: this.styles.getStyle(tableColumnMode),
      styles: this.styles,
      title: this.title,
    }
  }
}